// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-block-compare-date{position:fixed;top:45px;left:470px;right:0;z-index:1000}", ""]);
// Exports
module.exports = exports;
